<script>
    import * as Sentry from '@sentry/svelte';
    import { activeUserData, get_osm_uid_state } from './activeUserData.svelte.js';
    import { tick } from 'svelte';
    import { toggle_visit, keydownWrapper } from './lib.js';
    import { showContextMenu, mapDisplayMessage } from './Map.svelte';
    import { hapticsImpactLight, hapticsImpactMedium } from '$lib/haptics.js'


    let {
        osm_uid = null,
        label,
        token,
        map = null,
        autofocus = false,
        flyToOnBeen = false,
        capacitor,
        visitors,
    } = $props();

    let error = $state(null);
    let disabled = $state(false);
    let wait = $state(false);
    let longWait = $state(false);
    let the_button;
    let osm_uid_state = $derived.by(() => { return get_osm_uid_state (activeUserData.data, osm_uid); });
    let happy_state = $state(undefined); // A trigger to enforse checked/unchecked for the happy path
                                    // 'checked' - enforce checked
                                    // 'unchecked' - enfore unckeched  (not false not to mess with Svelte 5 reactivity)
    let checked = $derived(
                (happy_state == 'checked') ? true :
                (happy_state == 'unchecked') ? false :
                osm_uid_state.visited
            );

    $effect(() => {
        if(autofocus && the_button) {
            the_button.focus();
        }
    });

    if(!osm_uid) {
        Sentry.captureMessage("BeenButton created with an falsy osm_uid", { extra: { osm_uid } });
    }

    function onContextMenu(event) {
        if(capacitor) return;
        event.preventDefault(); // Prevent browser context menu
        event.stopPropagation();
        showContextMenu({el: event.currentTarget, osm_uid, label, flyToOnBeen, visitors });
    }

    async function toggleBeenTo(e) {
        if(wait || disabled) return;

        e.preventDefault();
        await hapticsImpactLight();
        disabled = true;

        if(!osm_uid) {
            Sentry.captureMessage('BeenButton/toggleBeenTo: empty osm_uid', { extra: { osm_uid_state, osm_uid } });
            return;
            // Note, the button will stay disabled
        }

        wait = true;
        longWait = false;
        happy_state = osm_uid_state.visited ? 'unchecked' : 'checked';
        let timeoutID = setTimeout(() => { longWait = true }, 300);
        error = await toggle_visit (map, osm_uid_state.visited ? 'remove' : 'add', { osm_uid, flyToOnBeen, token });
        if(timeoutID) clearTimeout(timeoutID);
        wait = false;
        longWait = false;
        happy_state = undefined;

        if(!error) {
            disabled = false;
        } else {
            await hapticsImpactMedium();
        }
        await tick();
        the_button.focus();
    }

    $effect(() => {
        if(error) {
            mapDisplayMessage({map, msg: error, type: 'danger'});
            const mymap_add_error = document.getElementById("mymap_add_error");
            if(mymap_add_error) {
                mymap_add_error.innerHTML = error;
            }
        }
    });

    let touchTimer;
    const pathLength = 11;
</script>
<!-- class:is-loading={disabled}-->
<!-- svelte-ignore a11y_autofocus -->
<button class="m-1 button is-small cursor-pointer"
    bind:this={the_button}
    id={osm_uid}
    disabled={disabled && longWait}
    class:wait={wait && longWait}
    class:is-danger={!!error} 
    class:is-success={osm_uid_state.visited && !osm_uid_state.transit}
    class:is-link={osm_uid_state.visited && osm_uid_state.transit}
    class:is-outlined={osm_uid_state.hidden}
    onclick={toggleBeenTo}
    onkeydown={keydownWrapper(toggleBeenTo)}
    oncontextmenu={onContextMenu}
    ontouchstart={(event) => { touchTimer = setTimeout(() => onContextMenu(event), 500 /* 500ms long press threshold */)}}
    ontouchend={() => clearTimeout(touchTimer)}
>
    <!--{#if capacitor}
        <svg class=svg-icon>
            <use xlink:href={osm_uid_state.visited ? "/i/fa.svg#circle-check" : "/i/fa.svg#circle"}/>
        </svg>
    {:else}
        <svg class=svg-icon>
            <use xlink:href={osm_uid_state.visited ? "/i/fa.svg#circle-check" : "/i/fa.svg#circle"}/>
        </svg>&nbsp;Been
    {/if}-->
    <svg class=svg-icon-alt viewBox="0 0 16 16" fill="none" stroke-linecap="round" stroke-width="1">
        <path d="M15 8a7 7 0 10-14 0 7 7 0 1014 0" />
        <path
            d="M5 9l2.2076 2.0069 3.8489-5.8865"
            stroke-dasharray={pathLength}
            stroke-dashoffset={(!checked) ? pathLength : 0}
            style="transition: stroke-dashoffset 0.3s ease;"
        />
    </svg>{#if !capacitor}&nbsp;Been{/if}
</button>

<style>
    button.wait {
        cursor: wait !important;
    }


.svg-icon-alt {
    display: inline-block;
    width: 1em;
    height: 1em;
    /*stroke-width: 1px;*/
    stroke: currentColor;
    /*fill: currentColor;*/
    position: relative;
    vertical-align: middle;
    top: -.125em;
    /*top: -0.075em;*/

    /*vertical-align: .5em;*/
    /*vertical-align: -0.2em;*/
}
</style>
